import React from "react";
import { Link } from "react-router-dom";

export default function CountCard({ summary }) {
  const items = [
    {
      label: "Policies",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M13.3224 9.00004H10.4515V12H13.3224C14.1289 12 ..."
            fill="#323544"
          />
        </svg>
      ),
      summary: summary?.totalPolicies,
      link: "/policies"
    },
    {
      label: "Quotations",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M3.25 5.5C3.25 4.25736 4.25736 3.25 5.5..."
            fill="#323544"
          />
        </svg>
      ),
      summary: summary?.totalQuotations,
      link: "/quotations"
    },
    {
      label: "Renewals",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M11.9985 2.50098C9.90741 2.50098 7.874..."
            fill="#323544"
          />
        </svg>
      ),
      summary: summary?.totalRenewals,
      link: "/renewals"
    },
  ];

  return (
    <div className="row row-xs clearfix">
      {items.map((obj) => (
        <div className="col-12 col-sm-6 col-md-4 col-xl-4" key={obj.label}>
          <Link to={obj.link}>
            <div
              className="card mg-b-20 card-custom"
              style={{
                background: "#003049",
                border: "none",
                borderRadius: "4px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px 20px",
                textAlign: "left",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    className="text-white mb-0"
                    style={{
                      fontSize: "1.175em",
                      fontWeight: "bold",
                      color: "#f2f2f2",
                    }}
                  >
                    {obj.label}
                  </span>

                  <div
                    className="card-icon"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "#f2f2f2",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {obj.icon}
                  </div>
                </div>

                <h2
                  className="text-white mb-1"
                  style={{ fontSize: "24px", color: "#f2f2f2" }}
                >
                  {obj.summary}{" "}
                  <span style={{ color: "#28A745", fontSize: "10px" }}>
                    {/* (+29%) */}
                  </span>
                </h2>

                <p
                  className="text-white mb-0"
                  style={{
                    fontSize: "0.875em",
                    fontWeight: "bold",
                    color: "#f2f2f2",
                  }}
                >
                  Total
                </p>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
}
